export default __webpack_public_path__ + "static/media/aboutPage.e944b842.jpg";